module.exports = __webpack_public_path__ + "static/media/sticker.114695b8.jpg";